import * as THREE from "three";

export const METALF = [
  {
    name: "Black Matt",
    listName: "METALF",
    texture: "./textures/metal/black matt/color_b.jpg",
    roughnessMap: "./textures/metal/black matt/metalness.jpg",
    normalMap: "./textures/metal/black matt/normal.png",
    metalnessMap: "./textures/metal/black matt/roughness.jpg",
    size: [0.1, 0.1, 0.1],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 1,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 7,
    emissive: false,
  },
  {
    name: "Frosted Silver",
    listName: "METALF",
    texture: "./textures/metal/frosted silver/color_c.jpg",
    roughnessMap: "./textures/metal/frosted silver/metalness.jpg",
    normalMap: "./textures/metal/frosted silver/normal.png",
    metalnessMap: "./textures/metal/frosted silver/roughness.jpg",
    size: [0.1, 0.1, 0.1],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 1,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
    emissive: false,
  },
  {
    name: "Polished Silver",
    listName: "METALF",
    // texture: "./textures/metal/polished silver/color_b.jpg",
    // roughnessMap: "./textures/metal/polished silver/metalness.jpg",
    normalMap: "./textures/metal/polished silver/polished2.png",
    // metalnessMap: "./textures/metal/polished silver/roughness.jpg",
    size: [1, 1, 1],
    offset: [0.0, 0.0],
    roughness: 0.1,
    metalness: 1,
    rotation: 1,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 3,
    emissive: false,
  },
  {
    name: "Maple",
    listName: "METALF",
    texture: "./textures/metal/Maple/color-b.webp",
    roughnessMap: "./textures/metal/Maple/roughness.webp",
    normalMap: "./textures/metal/Maple/normal.webp",
    //metalnessMap: "./textures/metal/511/roughness.png",
    size: [0.02, 0.75, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 0.5,
  },
  {
    name: "Oak",
    listName: "METALF",
    texture: "./textures/metal/Oak/color.webp",
    roughnessMap: "./textures/metal/Oak/roughness.webp",
    normalMap: "./textures/metal/Oak/normal.webp",
    //metalnessMap: "./textures/metal/511/roughness.png",
    size: [0.02, 0.75, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Dark Wenge",
    listName: "METALF",
    texture: "./textures/metal/Dark Wenge/color_c.webp",
    roughnessMap: "./textures/metal/Dark Wenge/roughness.webp",
    normalMap: "./textures/metal/Dark Wenge/normal.webp",
    //metalnessMap: "./textures/metal/511/roughness.png",
    size: [0.02, 0.75, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Dark Grey",
    listName: "METALF",
    texture: "./textures/metal/Dark Grey/color_b.webp",
    roughnessMap: "./textures/metal/Dark Grey/roughness.webp",
    normalMap: "./textures/metal/Dark Grey/normal.webp",
    //metalnessMap: "./textures/metal/511/roughness.png",
    size: [0.02, 0.75, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
];
